import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography, useTheme} from "@mui/material";
import {useTranslation} from "react-i18next";
import '../../../style/SalesMarketing.css';
import * as React from "react";
import Box from "@mui/material/Box";
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import {useNavigate} from "react-router-dom";

interface PromoCreationModalProps {
    open: boolean,
    isUpdate: boolean,
    handleCloseCreationModal: Function,
}

const PromoCreationModal = ({
                                open,
                                isUpdate,
                                handleCloseCreationModal
                            }: PromoCreationModalProps) => {
    const {t} = useTranslation(['salesmarketing']);
    const navigate = useNavigate();
    const theme = useTheme();

    return (
        <Dialog disableEscapeKeyDown fullWidth={true} open={open}
                onClose={() => {
                    return;
                }}>
            <DialogTitle>
                <Box sx={{display: 'flex', alignItems: 'center'}}>
                    <CheckCircleRoundedIcon color={"success"}/>
                    <Typography sx={{paddingLeft: "10px"}} fontWeight={"bold"} color={"primary"}>
                        {isUpdate ? t('salesmarketing:promo.updateForm.modalTitleSuccess') : t('salesmarketing:promo.createForm.modalTitleSuccess')}
                    </Typography>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={2} sx={{padding: "15px"}} alignItems={"center"}>
                    <Grid item>
                        <Typography color={"primary"} variant={"body1"} style={{whiteSpace: "pre-line"}}>
                            {t('salesmarketing:promo.updateForm.modalDescriptionSuccess')}
                        </Typography>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{backgroundColor: theme.palette.neutral.bright, padding: "15px"}}>
                <Button color={"accent"} onClick={() => {
                    handleCloseCreationModal();
                    navigate("/salesmarketing/promolist");
                }}>{t('salesmarketing:promo.buttons.close')}</Button>
            </DialogActions>
        </Dialog>
    );
}

export default PromoCreationModal;